<div *ngIf="ready">
  <div class="bg-white">
    <mat-card appearance="outlined">
      <div class="mainBody">
        <strong>Nuevo producto de stock</strong>
        <hr>
        <div class="flex-container">

          <div class="two-column">
            <div class="w-50">
              <app-input inputType="text" placeholder="Descripción" name="controlstock.description"
                [isRequired]="true" [(ngModel)]="controlstock.description"></app-input>
            </div>
            <div class="w-50">
              <mat-form-field class="inputWithoutHelp">
                <input type="number" matInput placeholder="Cantidad" name="controlstock.quantity" required
                  [(ngModel)]="controlstock.quantity">
              </mat-form-field>
            </div>

            <div class="w-50">
              <button mat-stroked-button (click)="save(controlstock)">
                <mat-icon>save</mat-icon>
                Guardar
              </button>
            </div>
          </div>

        </div>
      </div>
    </mat-card>
  </div>
</div>
